import { providerQueryOptions } from '@/queries/providers';
import { PUBLIC_QUERY_STALE_TIME } from '@/queries/queryOptions.helpers';

export const PROVIDERS_LIST_DESKTOP_PAGE_SIZE = 20;

type ProviderListQueryParams = {
  page: number;
  search: string;
  limit: number;
};

export const providerListQueryOptions = ({ page, search, limit }: ProviderListQueryParams) =>
  providerQueryOptions.list(
    {
      page,
      limit,
      filters: { ...(search ? { name: { $cont: search } } : {}), isActive: true },
    },
    { staleTime: PUBLIC_QUERY_STALE_TIME },
  );

export const providerListPrefetchQueryOptions = (params: Omit<ProviderListQueryParams, 'limit'>) =>
  providerListQueryOptions({ ...params, limit: PROVIDERS_LIST_DESKTOP_PAGE_SIZE });
